<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Play Video</div>
                <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin">
                        <template v-if="type == 'url'">
                            <iframe :src="url" controls width="100%" height="250"></iframe>
                        </template>
                        <template v-if="type == 'video'">
                            <v-playback name="v_play" :url="url" ></v-playback>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    var self;
    import {HTTP} from '../../../http-common';
    import CanvasVideo from 'vue-canvasvideo';
    import 'vue-canvasvideo/dist/vuecanvasvideo.min.css';
    import vPlayBack from 'v-playback';
    Vue.use(vPlayBack);

//    import 'video.js/dist/video-js.css'
//    import { videoPlayer } from 'vue-video-player'
//
//    import Vue from 'vue'
//    import vPlayBack from 'v-playback';
//    Vue.use(vPlayBack);

    Vue.use(CanvasVideo);

    export default {
        name: 'Play_Videos',
        mixins: [SessioMixin],
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                videoForPlay: "",
                videoThumbnail: "",
                url: '',
                type: '',
//                props: {
//                    src: { // the video source
//                        type: String,
//                        required: true
//                    },
//                    fps: { // frames per second, the playback speed
//                        type: Number,
//                        default: () => 25
//                    },
//                    showVideo: { // switch between playback on video or canvas
//                        type: Boolean,
//                        default: () => false
//                    },
//                    autoplay: { // automatically play the video
//                        type: Boolean,
//                        default: () => false
//                    },
//                    loop: { // loop the video infinitely
//                        type: Boolean,
//                        default: () => false
//                    },
//                    playPauseOnClick: { // toggle play/pause on click of video
//                        type: Boolean,
//                        default: () => false
//                    },
//                    resetOnLast: { // reset start after complete
//                        type: Boolean,
//                        default: () => false
//                    },
//                    cover: { // should the video cover within it's container (useful for backgrounds; cannot be used with 'square' prop)
//                        type: Boolean,
//                        default: () => false
//                    },
//                    square: { // should the video be centered vertically in a square container (cannot be used with 'cover' prop)
//                        type: Boolean,
//                        default: () => false
//                    },
//                    controls: { // show video playback controls
//                        type: Boolean,
//                        default: () => false
//                    }
//                },
            }
        },

        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.getSelectedVideo();
        },

        methods: {
            buttonBack() {
                self.$router.push('/backend/listvideos');
            },
            getSelectedVideo: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var videoId = segments[3];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    id: videoId,
                }
                self.showLoader();
                HTTP.post("playvideo", data, config)
                        .then(function (response) {
                            self.videoForPlay = response.data.content.video;
                            self.videoThumbnail = response.data.content.videoThumbnail;
                            self.type = response.data.content.type;
                            if(response.data.content.type == 'url') {
                                self.url = response.data.content.video_url;
                            } else {
                                self.url = response.data.content.video;
                            }
                            
                            //console.log(self.videoForPlay);
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/backend/gallery/PlayVideos.vue